import { MenuItem, Select, Input, FormControl, InputLabel, Typography } from '@mui/material';
import { Field, FieldProps } from 'formik';
import * as React from 'react';

import { IdName } from '../util';

interface IProps {
  items: IdName[];
  name: string;
  label: string;
  disabled?: boolean;
  onChange?: (key: string) => void;
  selectMultiple?: boolean;
  dataTestAddButton?: string;
  required?: boolean;
  unselectable?: boolean;
}

const DEBUG = false;

export const Selector = (props: IProps) => {
  const { items, label, name, dataTestAddButton, selectMultiple, disabled, required, unselectable = false } = props;
  DEBUG && console.log('Selector', 'render', props);
  return (
    <Field name={name}>
      {(formikProps: FieldProps) => {
        const errors = formikProps.form.errors;
        const error = errors[name];
        DEBUG && console.log('Selector', 'render field ', { formikProps, error, errors });
        return (
          <FormControl variant="standard" margin="normal" fullWidth error={!!error}>
            <InputLabel htmlFor={label}>{label}</InputLabel>
            <Select
              disabled={disabled}
              fullWidth
              required={required}
              multiple={selectMultiple}
              input={<Input data-test={dataTestAddButton} id={label} />}
              {...formikProps.field}
              onChange={(e, v) => {
                DEBUG && console.debug('Selector', 'change', { e, v });
                const value = e.target.value as string;
                if (props.onChange) {
                  props.onChange(value);
                }
                formikProps.form.setFieldValue(name, value);
              }}
            >
              {unselectable && !required && !selectMultiple && (
                <MenuItem value="">
                  <em>None</em>
                </MenuItem>
              )}
              {items.map((item: any, i) => (
                <MenuItem
                  data-test={`${dataTestAddButton}-${
                    typeof item.id === 'string'
                      ? item.id.toLowerCase()
                      : () => {
                          console.error('Selector', 'item.id is not a string', { item });
                          return '';
                        }
                  }-option`}
                  key={item.id}
                  value={item.id}
                  disabled={item.disabled || false}
                >
                  {item.name}
                </MenuItem>
              ))}
            </Select>
            {/*TODO - upgrade: fix typing?*/}
            {error ? <Typography color="red">{error as string}</Typography> : null}
          </FormControl>
        );
      }}
    </Field>
  );
};
